import React, { useState, useEffect, useRef } from "react";

import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";

import { i18n } from "../../translate/i18n";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import ColorPicker from "../ColorPicker";
import { IconButton, InputAdornment } from "@material-ui/core";
import { Colorize, LocalOfferRounded } from "@material-ui/icons";
import { corDoTextoDaEtiqueta } from "../../utils/estiloAstro";
import CloseIcon from "@material-ui/icons/Close";
import PaletteOutlinedIcon from "@material-ui/icons/PaletteOutlined";
import LabelOutlinedIcon from "@material-ui/icons/LabelOutlined";
import {
	modalPapel,
	modalHero,
	modalHeroLinha,
	modalHeroIcone,
	modalHeroEtiqueta,
	modalHeroTitulo,
	modalHeroSub,
	modalFechar,
	modalCorpo,
	modalSecao,
	modalSecaoTopo,
	modalSecaoIcone,
	modalSecaoTitulo,
	modalRodape,
	campoNavy,
	botaoPrimario,
	botaoSecundario
} from "../../utils/estiloNavy";

const useStyles = makeStyles(theme => ({
	root: {
		display: "flex",
		flexWrap: "wrap",
	},
	textField: {
		marginRight: theme.spacing(1),
		flex: 1,
	},

	btnWrapper: {
		position: "relative",
	},

	buttonProgress: {
		color: green[500],
		position: "absolute",
		top: "50%",
		left: "50%",
		marginTop: -12,
		marginLeft: -12,
	},
	formControl: {
		margin: theme.spacing(1),
		minWidth: 120,
	},
	colorAdorment: {
		width: 20,
		height: 20,
		borderRadius: 6,
		border: "1px solid rgba(0,0,0,0.1)",
	},

	// ── visual novo ──
	titulo: {
		display: "flex",
		alignItems: "center",
		gap: 12,
		"& h2": { display: "flex", alignItems: "center", gap: 12 },
	},
	tituloIcone: {
		width: 38,
		height: 38,
		borderRadius: 11,
		display: "grid",
		placeItems: "center",
		color: "#fff",
		background: "linear-gradient(135deg, #16a34a, #22c55e)",
		boxShadow: "0 6px 14px rgba(34,197,94,0.3)",
		flexShrink: 0,
	},
	previa: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		gap: 8,
		padding: "18px 12px",
		marginBottom: 14,
		borderRadius: 14,
		background: theme.palette.type === "dark"
			? "radial-gradient(300px 120px at 50% 0%, rgba(34,197,94,0.10), transparent 70%), rgba(255,255,255,0.02)"
			: "radial-gradient(300px 120px at 50% 0%, rgba(30,152,85,0.08), transparent 70%), #f7faf8",
		border: `1px dashed ${theme.palette.divider}`,
	},
	previaRotulo: {
		fontSize: "0.68rem",
		fontWeight: 700,
		letterSpacing: "0.08em",
		textTransform: "uppercase",
		color: theme.palette.text.secondary,
	},
	previaPilula: {
		display: "inline-flex",
		alignItems: "center",
		gap: 6,
		maxWidth: "100%",
		padding: "6px 14px",
		borderRadius: 20,
		fontSize: "0.9rem",
		fontWeight: 700,
		color: "#fff",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		transition: "background-color .2s ease",
	},
	paletaRotulo: {
		fontSize: "0.72rem",
		fontWeight: 700,
		color: theme.palette.text.secondary,
		margin: "12px 0 8px",
	},
	paleta: {
		display: "flex",
		flexWrap: "wrap",
		gap: 8,
	},
	amostra: {
		width: 30,
		height: 30,
		borderRadius: "50%",
		border: "none",
		cursor: "pointer",
		padding: 0,
		transition: "transform .15s ease, box-shadow .15s ease",
		"&:hover": { transform: "scale(1.12)" },
	},
	amostraAtiva: {
		boxShadow: `0 0 0 3px ${theme.palette.type === "dark" ? "#111614" : "#fff"}, 0 0 0 5px #1E9855`,
		transform: "scale(1.08)",
	},
	papel: modalPapel(theme, 480),
	hero: modalHero(theme),
	heroLinha: modalHeroLinha,
	heroIcone: modalHeroIcone,
	heroEtiqueta: modalHeroEtiqueta,
	heroTitulo: modalHeroTitulo,
	heroSub: modalHeroSub,
	fechar: { ...modalFechar, marginLeft: "auto", alignSelf: "flex-start" },
	corpo: modalCorpo(theme),
	secao: modalSecao(theme),
	secaoTopo: modalSecaoTopo,
	secaoIcone: modalSecaoIcone,
	secaoTitulo: modalSecaoTitulo(theme),
	rodape: { ...modalRodape(theme), justifyContent: "flex-end" },
	campo: campoNavy(theme),
	btnPrimario: botaoPrimario,
	btnSecundario: botaoSecundario(theme),
	// previa dentro do hero: um "cartao de atendimento" de mentira
	heroPrevia: {
		marginTop: 16,
		display: "flex",
		alignItems: "center",
		gap: 12,
		padding: "10px 12px",
		borderRadius: 14,
		background: "rgba(255,255,255,0.06)",
		border: "1px solid rgba(255,255,255,0.12)",
		backdropFilter: "blur(6px)",
	},
	heroPreviaAvatar: {
		width: 34, height: 34, borderRadius: "50%", flexShrink: 0,
		display: "flex", alignItems: "center", justifyContent: "center",
		fontWeight: 800, fontSize: 13, color: "#0b1220", background: "#e2e8f0",
	},
	heroPreviaLinhas: { flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 6 },
	heroPreviaBarra: { height: 7, borderRadius: 4, background: "rgba(255,255,255,0.16)" },
}));

// cores prontas para escolher com um clique
const CORES_PRONTAS = [
	"#1E9855", "#22c55e", "#0d9488", "#0ea5e9", "#2563eb", "#7c3aed",
	"#db2777", "#dc2626", "#ea580c", "#f59e0b", "#65a30d", "#475569",
];

const TagSchema = Yup.object().shape({
	name: Yup.string()
		.min(3, "Too Short!")
		.max(50, "Too Long!")
		.required("Required"),
	color: Yup.string().min(3, "Too Short!").max(9, "Too Long!").required(),
});

const TagModal = ({ open, onClose, tagId }) => {
	const classes = useStyles();

	const initialState = {
		name: "",
		color: "",
	};

	const [colorPickerModalOpen, setColorPickerModalOpen] = useState(false);
	const [tag, setTag] = useState(initialState);
	const nameRef = useRef();

	useEffect(() => {
		(async () => {
			if (!tagId) return;
			try {
				const { data } = await api.get(`/tags`); 

                
				const res = await api.get(`/tags`);
                const foundTag = res.data.find(t => t.id === tagId);
				if (foundTag) {
                    setTag(prevState => {
                        return { ...prevState, ...foundTag };
                    });
                }
			} catch (err) {
				toastError(err);
			}
		})();

		return () => {
			setTag({
				name: "",
				color: "",
			});
		};
	}, [tagId, open]);

	const handleClose = () => {
		onClose();
		setTag(initialState);
	};

	const handleSaveTag = async values => {
		try {
			if (tagId) {
				await api.put(`/tags/${tagId}`, values);
			} else {
				await api.post("/tags", values);
			}
			toast.success("Etiqueta salva com sucesso!");
			handleClose();
		} catch (err) {
			toastError(err);
		}
	};

	return (
		<div className={classes.root}>
			<Dialog open={open} onClose={handleClose} maxWidth={false} PaperProps={{ className: classes.papel }}>
				<Formik
					initialValues={tag}
					enableReinitialize={true}
					validationSchema={TagSchema}
					onSubmit={(values, actions) => {
						setTimeout(() => {
							handleSaveTag(values);
							actions.setSubmitting(false);
						}, 400);
					}}
				>
					{({ touched, errors, isSubmitting, values, setFieldValue }) => (
						<Form style={{ display: "flex", flexDirection: "column", minHeight: 0, flex: 1 }}>
							<div className={classes.hero}>
								<div className={classes.heroLinha}>
									<div className={classes.heroIcone}>
										<LocalOfferRounded />
									</div>
									<div style={{ minWidth: 0 }}>
										<div className={classes.heroEtiqueta}>Etiquetas</div>
										<div className={classes.heroTitulo}>{tagId ? "Editar etiqueta" : "Nova etiqueta"}</div>
										<div className={classes.heroSub}>Veja abaixo como ela aparece no atendimento.</div>
									</div>
									<IconButton size="small" onClick={handleClose} className={classes.fechar}>
										<CloseIcon fontSize="small" />
									</IconButton>
								</div>

								{/* prévia: como a etiqueta aparece num atendimento */}
								<div className={classes.heroPrevia}>
									<span className={classes.heroPreviaAvatar}>MS</span>
									<div className={classes.heroPreviaLinhas}>
										<span className={classes.heroPreviaBarra} style={{ width: "55%" }} />
										<span
											className={classes.previaPilula}
											style={{
												alignSelf: "flex-start",
												padding: "3px 10px",
												fontSize: "0.78rem",
												backgroundColor: values.color || "#94a3b8",
												color: corDoTextoDaEtiqueta(values.color || "#94a3b8"),
												boxShadow: `0 4px 14px ${values.color || "#94a3b8"}66`,
											}}
										>
											<LocalOfferRounded style={{ fontSize: 13, flexShrink: 0 }} />
											<span style={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis" }}>
												{values.name || "Nome da etiqueta"}
											</span>
										</span>
									</div>
								</div>
							</div>

							<div className={classes.corpo}>
								<div className={classes.secao}>
									<div className={classes.secaoTopo}>
										<span className={classes.secaoIcone}><LabelOutlinedIcon /></span>
										<span className={classes.secaoTitulo}>Nome</span>
									</div>
									<Field
										as={TextField}
										label="Nome da etiqueta"
										placeholder="Ex: Aguardando documento"
										autoFocus
										name="name"
										inputRef={nameRef}
										error={touched.name && Boolean(errors.name)}
										helperText={touched.name && errors.name}
										variant="outlined"
										size="small"
										className={classes.campo}
										fullWidth
									/>
								</div>

								<div className={classes.secao} style={{ animationDelay: "60ms" }}>
									<div className={classes.secaoTopo}>
										<span className={classes.secaoIcone}><PaletteOutlinedIcon /></span>
										<span className={classes.secaoTitulo}>Cor</span>
									</div>
									<div className={classes.paleta}>
										{CORES_PRONTAS.map(cor => (
											<button
												key={cor}
												type="button"
												title={cor}
												className={`${classes.amostra} ${
													String(values.color).toLowerCase() === cor.toLowerCase()
														? classes.amostraAtiva
														: ""
												}`}
												style={{ backgroundColor: cor }}
												onClick={() => setFieldValue("color", cor)}
											/>
										))}
									</div>
									<div className={classes.paletaRotulo}>Ou escolha outra cor</div>
									<Field
										as={TextField}
										label="Código da cor"
										name="color"
										id="color"
										onFocus={() => {
											setColorPickerModalOpen(true);
											nameRef.current.focus();
										}}
										error={touched.color && Boolean(errors.color)}
										helperText={touched.color && errors.color}
										InputProps={{
											startAdornment: (
												<InputAdornment position="start">
													<div
														style={{ backgroundColor: values.color || "#e2e8f0" }}
														className={classes.colorAdorment}
													></div>
												</InputAdornment>
											),
											endAdornment: (
												<IconButton
													size="small"
													color="default"
													onClick={() => setColorPickerModalOpen(true)}
												>
													<Colorize fontSize="small" />
												</IconButton>
											),
										}}
										variant="outlined"
										size="small"
										className={classes.campo}
										fullWidth
									/>
									<ColorPicker
										open={colorPickerModalOpen}
										handleClose={() => setColorPickerModalOpen(false)}
										onChange={color => {
											values.color = color;
											setTag(() => {
												return { ...values, color };
											});
										}}
									/>
								</div>
							</div>

							<div className={classes.rodape}>
								<Button onClick={handleClose} disabled={isSubmitting} className={classes.btnSecundario}>
									Cancelar
								</Button>
								<Button type="submit" disabled={isSubmitting} className={classes.btnPrimario}>
									{isSubmitting && <CircularProgress size={16} style={{ color: "#fff", marginRight: 8 }} />}
									{tagId ? "Salvar etiqueta" : "Criar etiqueta"}
								</Button>
							</div>
						</Form>
					)}
				</Formik>
			</Dialog>
		</div>
	);
};

export default TagModal;
